<template>
  <right-panel :datas="connects" ref="rightPanel" @onClose="onClose">
    <div slot="header">
      <translate>Config</translate>
    </div>
    <div slot="content" class="linux-config project-connect" v-if="m">
      <div class="vertify-content">
        <el-row>
          <el-col :span="8" class="text-right"><translate>Default Username</translate><span>:</span></el-col>
          <el-col :span="8">
            <el-select v-model="defaultUser">
              <el-option v-for="option in m.usernameList" :key="option.id" :label="option" :value="option"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row v-if="m.os === 'linux'">
          <el-col :span="8" class="text-right"><translate>Security Mode</translate><span>:</span></el-col>
          <el-col :span="6">
            <div v-if=" m.safe.network_safe_mode"><translate>Opening</translate></div>
            <div v-if=" !m.safe.network_safe_mode"><translate>Closed</translate></div>
          </el-col>
        </el-row>
        <el-row v-if="m.os === 'linux'">
          <el-col :span="8" class="text-right"><translate>CloudLinker Authentication</translate><span>:</span></el-col>
          <el-col :span="15">
            <div v-if="m.resource.csos_check==='open'"><translate>Opening</translate></div>
            <div v-if=" m.resource.csos_check!=='open'"><translate>Closed</translate></div>
            <div>(<translate>When permissions is enabled, webssh does not support KEY authentication.</translate>)</div>
          </el-col>
        </el-row>
        <el-row class="l-h-16" v-if="m.os === 'linux'">
          <el-col :span="8" class="text-right"><translate>Destination Host Authentication</translate><span>:</span></el-col>
          <el-col :span="6" class="">
            <div v-if=" m.resource.autologin===1"><translate>Opening</translate></div>
            <div v-if=" m.resource.autologin!==1"><translate>Closed</translate></div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="setDefaultUsername" :loading="submiting"><translate>Save</translate></el-button>
      <el-button  @click="onClose()"><translate>Cancel</translate></el-button>
    </div>
  </right-panel>
</template>
<script>
import STORE_CONST from '../../../store/consts'
import RightPanel from '../../common/right-panel'
export default {
  name: 'linuxConfig',
  props: {
    items: {
      required: true
    }
  },
  data () {
    return {
      connects: null,
      m: null,
      defaultUser: '',
      submiting: false
    }
  },
  computed: {
  },
  mounted () {
  },
  created () {
    console.log('linux---config')
    setTimeout(() => {
      this.getTunelInfo(this.connects.project_resource_id)
    }, 300)
  },
  methods: {
    onClose () {
      // && connects.agentVersion<'2.4.0'
      this.connects = null
      this.$emit('onClosePanel')
    },
    getTunelInfo (id) {
      const params = {
        project_resource_id: id
      }
      this.$store.dispatch(STORE_CONST.WORKGROUP.GET_TUNNEL_INFO, params).then((res) => {
        console.log('res', res)
        this.m = res
        let extension = JSON.parse(res.project_resource.extension)
        if (res.os === 'linux') {
          if (extension && extension.login_username.length > 0) {
            this.m.usernameList = extension.login_username
          } else {
            this.m.usernameList = []
          }
        } else if (res.os === 'win32') {
          if (extension && extension.login_username.length > 0) {
            this.m.usernameList = extension.login_username
          } else {
            this.m.usernameList = []
          }
        }
        if (res.project_resource.default_username) {
          this.defaultUser = res.project_resource.default_username
        } else {
          this.defaultUser = this.m.usernameList[0]
        }
      })
    },
    setDefaultUsername () {
      const params = {
        project_resource_id: this.connects.project_resource_id,
        data: {
          default_username: this.defaultUser
        }
      }
      this.submiting = true
      console.log('default', params)
      this.$store.dispatch(STORE_CONST.WORKGROUP.SET_PROJECT_DEFAULT_NAME, params).then((res) => {
        console.log('res', res)
        this.submiting = false
        this.$notify({
          type: 'success',
          message: this.$gettext('Save successfully!')
        })
        this.onClose()
      })
    }
  },
  watch: {
    'items': {
      handler: function (newVal) {
        if (this.connects) {
          this.connects = null
          setTimeout(() => {
            this.connects = this.items
          }, 300)
        } else {
          this.connects = this.items
        }
        console.log('connects', this.connects)
      },
      deep: true
    }
  },
  components: {
    RightPanel
  }
}
</script>
<style lang="scss" rel="stylesheet/scss">
@import '../../../assets/css/variable';
.linux-config{
  .l-h-16{
    line-height: 16px;
  }
  .l-h-32{
    line-height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// linux-config.vue?7660e36c